import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
    customersRequest: ["options"],
    customersCountRequest: [],
    customerImportsRequest: ["businessId", "options"],
    customerImportRequest: ["importId"],
    uploadRequest: ["businessId", "audienceId", "name", "file"],
    applyUpload: ["id", "batchNo", "mode"],
    entriesRequest: ["importId"],
    audienceMembersRequest: ["audienceId", "options"],
    audienceCandidateSegmentsRequest: ["audienceId"],
    audienceCandidateTagsRequest: ["audienceId"],
    saveAudienceCandidateMetadataRequest: ["audienceId", "metadata"],
    applyAudienceCandidatesRequest: ["audienceId"],
    audienceBulkInvitationsRequest: ["audienceId"],
    audienceBatchesRequest: ["audienceId"],
    downloadCsvRequest: [],
    downloadAudienceCsvRequest: ["audienceId"],
    submitCustomerEnrichmentRequest: ["businessId", "file"],
    customerEnrichmentsRequest: ["businessId", "options"],
    customerEnrichmentStatusRequest: ["businessId", "requestId"],
    customerEnrichmentItemsRequest: ["businessId", "requestId", "options"],
    bulkPlanInviteRequest: ["businessId", "inviteData"],
    businessCustomerRecordRequest: ["businessCustomerId"],
    linkBusinessCustomerRequest: ["secondaryBusinessCustomerId", "primaryBusinessCustomerId", "reason"],
    unlinkBusinessCustomerRequest: ["secondaryBusinessCustomerId"],
    canonicalBusinessCustomerRequest: ["secondaryBusinessCustomerId"],
    businessCustomerSummaryRequest: ["businessCustomerId"],
    secondaryBusinessCustomersRequest: ["bcId", "options"],
    secondaryBusinessCustomersCountRequest: ["bcId"],
    createBusinessCustomerRequest: ["businessId", "customerDto"],
    updateBusinessCustomerSimpleRequest: ["id", "customerDto"],
    createAudienceRequest: ["audienceDto"],

    customersSuccess: ["customers"],
    customersCountSuccess: ["counts"],
    customerImportsSuccess: ["customerImports"],
    customerImportSuccess: ["customerImport"],
    uploadSuccess: ["document"],
    applyUploadSuccess: ["fileImported"],
    entriesSuccess: ["entriesList"],
    audienceMembersSuccess: ["audienceMembers"],
    audienceCandidateSegmentsSuccess: ["audienceCandidateSegments"],
    audienceCandidateTagsSuccess: ["audienceCandidateTags"],
    saveAudienceCandidateMetadataSuccess: ["audienceCandidateMetadata"],
    applyAudienceCandidatesSuccess: ["applyCandidatesResult"],
    audienceBulkInvitationsSuccess: ["audienceBulkInvitations"],
    audienceBatchesSuccess: ["audienceBatches"],
    downloadCsvSuccess: ["csv"],
    downloadAudienceCsvSuccess: ["csv"],
    submitCustomerEnrichmentSuccess: ["customerEnrichment"],
    customerEnrichmentsSuccess: ["customerEnrichments"],
    customerEnrichmentStatusSuccess: ["customerEnrichmentStatus"],
    customerEnrichmentItemsSuccess: ["customerEnrichmentItems", "requestId"],
    bulkPlanInviteSuccess: ["details"],
    businessCustomerRecordSuccess: ["customerRecord"],
    linkBusinessCustomerSuccess: ["businessCustomer"],
    unlinkBusinessCustomerSuccess: ["businessCustomer"],
    canonicalBusinessCustomerSuccess: ["businessCustomer"],
    businessCustomerSummarySuccess: ["businessCustomerSummary"],
    secondaryBusinessCustomersSuccess: ["secondaryBusinessCustomers"],
    secondaryBusinessCustomersCountSuccess: ["secondaryBusinessCustomersCount"],
    createBusinessCustomerSuccess: ["businessCustomer"],
    updateBusinessCustomerSimpleSuccess: ["businessCustomer"],
    createAudienceSuccess: ["audience"],

    customerFailure: ["error"],
    customersCountFailure: ["error"],
    customerImportsFailure: ["error"],
    customerImportFailure: ["error"],
    uploadFailure: ['error'],
    applyUploadFailure: ['error'],
    entriesFailure: ['error'],
    audienceMembersFailure: ['error'],
    audienceCandidateSegmentsFailure: ['error'],
    audienceCandidateTagsFailure: ['error'],
    saveAudienceCandidateMetadataFailure: ['error'],
    applyAudienceCandidatesFailure: ['error'],
    audienceBulkInvitationsFailure: ['error'],
    audienceBatchesFailure: ['error'],
    downloadCsvFailure: ["error"],
    downloadAudienceCsvFailure: ["error"],
    submitCustomerEnrichmentFailure: ["error"],
    customerEnrichmentsFailure: ["error"],
    customerEnrichmentStatusFailure: ["error"],
    customerEnrichmentItemsFailure: ["error"],
    bulkPlanInviteFailure: ["error"],
    businessCustomerRecordFailure: ["error"],
    linkBusinessCustomerFailure: ["error"],
    unlinkBusinessCustomerFailure: ["error"],
    canonicalBusinessCustomerFailure: ["error"],
    businessCustomerSummaryFailure: ["error"],
    secondaryBusinessCustomersFailure: ["error"],
    secondaryBusinessCustomersCountFailure: ["error"],
    createBusinessCustomerFailure: ["error"],
    updateBusinessCustomerSimpleFailure: ["error"],
    createAudienceFailure: ["error"],
})

export const CustomersTypes = Types;
export default Creators